module.exports = __webpack_public_path__ + "img/ci_logo.fde96a6b.png";